import { PkChip } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { memo, useMemo } from 'react';

import { useLivescoresTabs } from '../../hooks/tabs';
import type { LivescoreTab } from '../../store/types';
import { scrollToTab } from '../../utils/scroll';
import { track } from '../../utils/tracking';

import { withErrorBoundary } from '@shared/ErrorBoundary';

import * as styles from './styles.module.scss';

const CalendarTab = ({ tab, tabIndex }: { tab: LivescoreTab; tabIndex?: number }) => {
  const { selectedTab, isLoading, selectedTabIndex } = useLivescoresTabs();

  const { id } = tab;

  const isSelected = useMemo(() => id === selectedTab?.id, [id, selectedTab]);

  const handleClick = () => {
    if (isLoading) return;
    scrollToTab(id);

    if (tabIndex !== selectedTabIndex) {
      track(`Click date ${tabIndex > selectedTabIndex ? 'future' : 'past'}`, 'uefa_calendar_date');
    }
  };

  const date = useMemo(() => {
    if (!tab.date) return '-';

    const d = dayjs(tab.date);

    if (d.isSame(dayjs(), 'year')) {
      return d.format('ddd D MMM');
    }

    return d.format('ddd D MMM YYYY');
  }, [tab.date]);

  return (
    <PkChip
      id={`calendar-tab-${id}`}
      className={clsx(styles.tab, isLoading && styles.disabled)}
      selected={isSelected}
      onPkClick={handleClick}
    >
      <span className='pk-font--base-regular pk-font-size--s pk-text--nowrap'>{date}</span>
    </PkChip>
  );
};

export { CalendarTab as PureCalendarTab };

export default withErrorBoundary(memo(CalendarTab));
